import React, { memo } from 'react';
import { ArrowForward } from '@yme/assets/icons';
import { BTN_DARK_THEME, CONTAINED_VARIANT, SIZE_44, Button, TRAILING_ICON, } from '@yme/atoms/button';
import { useWindowSize } from '@yme/hooks/index';
import { colorCoreWhite1000 } from '@yme/tokens/colors';
import { HeadingLevel3 } from '@yme/tokens/typography';
import { LinkStyled, CardWrapperStyled } from './styled';
function CategoryPreviewSectionCardComponent(props) {
    const { isRightToLeft = false, cardProps } = props;
    const { link, text } = cardProps.button;
    const { isMobileView } = useWindowSize();
    const imageUrl = cardProps.image?.src || '';
    return isMobileView ? (React.createElement(LinkStyled, { to: link },
        React.createElement(CardWrapperStyled, { imageUrl: imageUrl },
            React.createElement(HeadingLevel3, { color: colorCoreWhite1000 }, text)))) : (React.createElement(CardWrapperStyled, { imageUrl: imageUrl },
        React.createElement(LinkStyled, { to: link },
            React.createElement(Button, { width: "unset", buttonVariant: CONTAINED_VARIANT, hasIconButton: TRAILING_ICON, iconComponent: ArrowForward, size: SIZE_44, isRightToLeft: isRightToLeft, label: text, colorSchema: BTN_DARK_THEME }))));
}
export const CategoryPreviewSectionCard = memo(CategoryPreviewSectionCardComponent);
CategoryPreviewSectionCard.displayName = 'CategoryPreviewSectionCard_Component';
